module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-stepup-popup"
  }, [_c('div', [_c('div', {
    staticClass: "popup-header"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "popup-close-button",
    attrs: {
      "data-close": "",
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', {
    staticClass: "popup-close-button-span"
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('div', {
    ref: "stepup",
    staticClass: "donate-stepup-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('h3', {
    staticClass: "donate-stepup-title"
  }, [(_vm.thankyouText) ? _c('span', [_vm._v(_vm._s(_vm.thankyouText))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "cms-stepup-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-header-logo"
  }, [_c('img', {
    staticClass: "popup-logo",
    attrs: {
      "src": "https://www.wwf.org.au/ecThemes/3/Images/WWF-RA-lockup-logo.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcc81d88","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/StepUp.vue
// module id = 813
// module chunks = 0